import { Navigate, useLocation } from 'react-router-dom';
import type { FC, ReactNode } from 'react';

interface RequireAuthProps {
  children?: ReactNode;
}

const RequireAuth: FC<RequireAuthProps> = ({ children }) => {
  const location = useLocation();
  if (!localStorage.getItem('uvp_access_token')) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
};

export default RequireAuth;
